

// Require

const { id, log, pi, sin, cos, vh } = require("../std/index")

const { Slice } = require("./master")

const cr = (deg) => deg * pi / 50;


//
// "Superior Texture & Taste" Slice
//

module.exports = class SuperiorSlice extends Slice {
  constructor($host, config) {
    super($host, config);

    this.dom.parts = $('.part', $host);
    this.dom.central = $('.central', $host);

    this.tween = this.prepareTween();
  }

  prepareTween() {
    const partConfig = [
      { rad: 32, θ: cr(-8), start: -100, end: 0 },    // Hanging sausage
      { rad: 35, θ: cr(0), start: -100, end: 0 },     // Grinder
      { rad: 44, θ: cr(-7), start: -100, end: 0 },    // Boerwors
      { rad: 55, θ: cr(56), start: -100, end: 0 },    // Apron
      { rad: 39, θ: cr(60), start: -100, end: 0 },    // Plain Sausage
      { rad: 43, θ: cr(47), start: -100, end: 0 },    // Glove
      { rad: 53, θ: cr(46), start: -100, end: 0 },    // Pepper Grinder (left)
      { rad: 28, θ: cr(8), start: -100, end: 0 }      // Salt Shaker (right)
    ];

    const radialToCartesian = (r, θ) => {
      return [(r * cos(θ)), (r * sin(θ))];
    };

    const tl = new TimelineLite({ paused: true });

    for (let i = 0; i < this.dom.parts.length; i++) {
      const part = this.dom.parts[i];
      const { rad, θ, start, end } = partConfig[i];
      const [x1, y1] = radialToCartesian(rad, θ);
      const [x2, y2] = radialToCartesian(rad * 3, θ);

      tl.fromTo(part, 0.8,
        { rotation: start, x: vh(x2), y: vh(y2) },
        { rotation: end, x: vh(x1), y: vh(y1), ease: Power2.easeOut }, 0.05 * i);
    }

    tl.fromTo(this.dom.central, 1, { y: 40, alpha: 0 }, { y: 0, alpha: 1, ease: Power4.easeOut }, 0);

    return tl;
  }

  onProgress(p) {
    this.tween.seek(p);
  }
};
